import { Link } from "react-router-dom";
import styles from "./CtaBand.module.css";
import Icon from "./Icons";
import useSiteSettings from "../hooks/useSiteSettings";

/** Closing conversion band, reused at the foot of every service page. */
export default function CtaBand() {
  const { doctor } = useSiteSettings();
  return (
    <section className={styles.band}>
      <div className={`u-shell ${styles.inner}`}>
        <div className={styles.copy}>
          <h2 className={styles.heading}>Start with an assessment.</h2>
          <p className={styles.text}>
            A first visit is history, full physical assessment, first treatment,
            and the plan you leave with. Clinic and home visits across Gurugram.
          </p>
        </div>

        <div className={styles.actions}>
          <Link to="/contact" className={styles.primary}>
            Book a Consultation
            <Icon name="arrow" size={17} />
          </Link>
          <a
            href={`https://wa.me/${doctor.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.secondary}
          >
            <Icon name="whatsapp" size={17} />
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
